<template>
  <div class="multiCity container_w dis_bo">
      <bread-crumb :crumbList="crumbList"></bread-crumb>
      <page-header :headerTitle="headerTitle"></page-header>
      <nav-book :isMulti="true"></nav-book>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader/PageHeader";
import NavBook from "@/components/HomeComponents/HomeNav/NavBook";
import BreadCrumb from "@/components/BreadCrumb/BreadCrumb";
export default {
  components: {
    PageHeader,
    NavBook,
    BreadCrumb
  },
  name: "multiCity",
  data() {
    return {
        crumbList:[
            {
                name:'Book a Flight',
                url:'bookflight'
            },
            {
                name:'Multi-City Flight',
                url:''
            }
        ],
        headerTitle:'Multi-City Flight'
    };
  },
  props: {},
  watch: {},
  methods: {},
  filters: {},
  computed: {},
  created() {
    
  },
  mounted() {},
  destroyed() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="less" scoped>
  

</style>
